module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/core-js/library/modules/$.library.js
 ** module id = 11
 ** module chunks = 2
 **/